import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import styled from '@emotion/styled';

import ActionButton from './ActionButton';
import ActionsMenuButton from './ActionsMenuButton';

import SpinnerBlock from '../../../common/SpinnerBlock';
import Lock from '../../../common/Lock';
import Toogle from '../../../common/Toogle';
import DisplayMoreWrapper from '../../../common/DisplayMoreWrapper';

import {
  getYandexStoreImageMin,
  checkOrderConfirmation,
  getProductEncodedUrl,
  parseError,
} from '../../../../helpers';

import { TAG_COLORS } from '../../../../config';

import { useEffect } from 'react';
import { showModal } from '../../../../actions/modal';
import { useSelector } from 'react-redux';
import { fetchExpirationDaysCalculateBatch } from '../../../../actions/auth';
import { toast } from 'react-toastify';
import { showExpirationDate } from '../../../../config';
import { fetchPostOzonFbo, fetchUpdateOrderItems } from '../../../../actions/orders';
import Checkbox from '../../../common/Checkbox';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  position: relative;
  box-shadow: none;
  border: 1px solid #ebebeb;

  .head-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .head-row-reserve {
      display: flex;
      align-items: center;
      margin-right: 20px;
      margin-bottom: 15px;
    }

    .head-row-buttons {
      margin-bottom: 10px;

      .text-xl-right {
        text-align: left !important;
      }
    }
  }

  .buttons-panel {
    > * {
      margin-right: 4px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .header-title {
    margin-bottom: 1px;
    margin-right: 10px;
  }

  .dropdown-menu {
    position: absolute;
    will-change: transform;
    top: 0;
    left: 0;
    transform: translate3d(0px, 35px, 0px);

    .dropdown-item {
      cursor: pointer;
      padding-left: 5px;
      padding-right: 5px;

      &.help-tooltip-wrapper {
        margin-left: 0;
        color: #bcbdc1 !important;
        background-color: transparent !important;
      }
    }
  }

  .bootstrap-table {
    .table {
      margin-bottom: 0;
    }

    .fixed-table-container {
      overflow-x: auto;

      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        background-color: white;
      }

      &::-webkit-scrollbar-track {
        background-color: white;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #6e768e;
        border-radius: 8px;
      }

      &::-webkit-scrollbar-width {
        width: 5px;
      }
    }

    .image-td {
      width: 35px;
      padding-right: 5px !important;
      padding-left: 5px !important;

      .image-block {
        width: 25px !important;
        height: 25px !important;
      }
    }

    .item-name {
      font-weight: 700;
      color: #343a40;
    }

    .item-article {
      font-size: 10px;
      color: #72747b;
    }

    .item-subname {
      font-size: 10px;
      color: #98a6ad;
    }

    .item-quantity {
      cursor: pointer;
      color: #7e57c2;

      &.disabled {
        color: #343a40;
        cursor: unset;
      }
    }

    .item-stock {
      font-size: 10px;
      color: #7b7a7a;
    }

    .delivery-placeholder {
      color: #7b7a7a;
    }

    .item-price {
      cursor: pointer;
      color: #7e57c2;
      white-space: nowrap;

      &.disabled {
        color: #343a40;
        cursor: unset;
      }
    }

    .item-nds {
      font-size: 10px;
      color: #7b7a7a;
    }

    .item-sum {
      cursor: pointer;
      white-space: nowrap;

      &.disabled {
        cursor: unset;
      }
    }

    .item-status {
      position: relative;
      font-size: 10px;
      text-transform: uppercase;
      white-space: nowrap;

      &.item-status-green {
        color: #1abc9c;
      }

      &.item-status-red {
        color: #f1556c;
      }

      &.item-status-orange {
        color: #f7b84b;
      }
    }

    .multiple-item-status {
      .item-status {
        span {
          display: block;
          font-size: 11px;
          color: #98a6ad;
          margin-top: 3px;
          text-transform: initial;
        }

        &:not(:last-child) {
          padding-bottom: 15px;
          margin-bottom: 15px;
          border-bottom: 1px solid #dee2e6;
        }
      }
    }

    .item-remove {
      cursor: pointer;
    }
  }

  .bottom-block {
    border-top: 1px solid #dee2e6;
    padding-top: 15px;
    margin: 0;

    .add-item {
      color: #7e57c2;
      cursor: pointer;
    }

    .refresh-reserve {
      color: #f772a7;
      cursor: pointer;

      &.disabled {
        color: #7b7a7a;
        cursor: default;
      }
    }

    .items-total {
      > div {
        margin-bottom: 5px;
      }
    }
  }

  .tags-wrapper {
    position: absolute;
    padding: 0 1.5rem;
    left: 0;
    top: 0;
    display: flex;

    .tag {
      border-radius: 0 0 10px 10px;
      margin: 0 10px 0 0;
      height: 16px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      font-size: 8px;
      color: white;
      cursor: pointer;

      :last-of-type {
        margin: 0;
      }
    }
  }

  .dropzone-wrapper {
    margin-top: 20px;

    .dropzone {
      display: flex;
      align-items: center;
      min-height: initial;
      height: 85px;

      .fe-upload {
        margin-bottom: 10px;
      }
    }
  }

  .permission {
    .help-tooltip {
      left: -10px;
    }
  }

  .reserve-toogle {
    width: 200px;
    margin: 0 0 0 10px;

    span {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #6e768e;
    }
  }

  @media (max-width: 960px) {
  }

  .expirationDays {
    cursor: pointer;
    color: #7e57c2;
    text-align: center;
    font-weight: 500;
  }

  .red-number {
    color: var(--red);
  }

  .calculateBatch {
    text-align: center;
    padding-right: 50px;
  }

  .osg-cell {
    position: relative;
    text-align: center;
  }

  .expiration-block {
    position: absolute;
    display: inline-block;
    vertical-align: top;
    margin-left: 4px;
    color: black;
  }

  .icon-green {
    color: #1abc9c;
  }

  .mass-edit-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .thead-light {
    .help-tooltip-wrapper {
      width: 108px;
      position: relative;
      i {
        bottom: 10px;
        position: absolute;
        right: 10px;
      }
    }
  }

  .batch-info {
    width: 160px;
    // display: -webkit-box;
    // -webkit-line-clamp: 3;
    // -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  }

  .osg-tooltip {
    display: inline-block;
    margin-bottom: 8px;
  }

  .cell-hover {
    cursor: pointer;
  }

  .checkbox-icon {
    margin-bottom: -10px;
  }

  .cn-mode-tooltip {
    right: -6px !important;
    top: -11px;
  }

  .lock-tooltip {
    right: 20px !important;
    top: 9px !important;
  }
`;

const DesktopMainBlock = (props) => {
  const {
    loadingOrder,
    currentOrder,
    handleEditTag,
    isNew,
    permissions,
    refreshReservePermission,
    handleUpdateDeliveryResult,
    handleConfirmation,
    isManualWarehouse,
    loadingSticker,
    loadingUploadFbmDocsButton,
    handlePacking,
    handleSendPackingControl,
    handleDownloadSticker,
    showActions,
    showUploadFbmDocsButton,
    haveProductsWithoutReserve,
    setShowActions,
    handleUploadToFulfillment,
    uploadToFulfilmentLoading,
    handleSetDelivery,
    handleAcceptReturn,
    handleRefreshReserve,
    handleCancel,
    handleCopyOrder,
    handleImportFromExcel,
    sortedData,
    handleOpenItemModal,
    currencySymbol,
    getItemStatusLabel,
    itemsStatuses,
    handleRemoveItem,
    handleAddItem,
    allQuantity,
    sum,
    factSum,
    getTotalNds,
    haveProducts,
    getNdsValue,
    history,
    itemsEditablePermission,
    handleSendEmail,
    currentWarehouse,
    dispatch,
    handleEditOrder,
    getRootProps,
    getInputProps,
    filesUploadLoading,
    handleNewTicket,
    handleOpenEditSale,
    handleOpenPhoneCallBack,
    handleExportExcel,
    handleUploadFbmDocsButton,
    defaultReserveOrders,
    handleChangeNeedReserve,
    handleInvoice,
    hasDiscount,
    getPriceBeforeDiscount,
    actualizeOrder,
    worksheetDataRequirements,
    handleUploadDriverPermit,
    setLoadingDriverPermit,
    loadingDriverPermit,
    handleEditOrderItems,
    currentPackingMaterials,
    setCurrentPackingMaterials,
    isDraft,
    setIsDraft,
    unsavedMaterials,
    setUnsavedMaterials,
    worksheetDataFormContent,
    updateBatch,
    switchBatchUpdate,
  } = props;

  const [isUseExpirationMode, setIsUseExpirationMode] = useState();
  const authData = useSelector((state) => state.auth);
  const deliveryInfo = useSelector((state) => state.orders.deliveryInfo);
  const warehouses = useSelector((state) => state.orders.warehouses);
  const { account } = useSelector((state) => state.auth);
  const worksheetShipmentCode = useSelector((state) => state.orders?.worksheetShipmentCode);
  const calculateBatchValues = useSelector((state) => state.auth.expirationDaysCalculateBatch);

  const [retailBatchCalculated, setRetailBatchCalculated] = useState(false);

  const adminMode = localStorage.getItem('adminPanel');

  const { t, i18n } = useAutoTranslation();

  const currentLocale = i18n.language;

  let currentDelivery = null;
  if (currentOrder.delivery) {
    currentDelivery = deliveryInfo.filter(
      (delivery) => delivery.deliveryCode === currentOrder.delivery.deliveryCode,
    );
  }

  useEffect(() => {
    setCurrentPackingMaterials(currentOrder.items);
  }, [currentOrder.items]);

  useEffect(() => {
    defineExpirationMode();
  }, [sortedData]);

  useEffect(() => {
    if (showExpirationDate(currentOrder)) {
      getExpirationDaysCalculated();
    }
  }, [isUseExpirationMode]);

  useEffect(() => {
    if (showExpirationDate(currentOrder) && updateBatch) {
      getExpirationDaysCalculated();
    }
  }, [currentOrder]);

  useEffect(() => {
    if (
      worksheetShipmentCode &&
      currentDelivery?.[0]?.fbmType === 'RETAIL_NETWORK' &&
      !retailBatchCalculated
    ) {
      getExpirationDaysCalculated();
      setRetailBatchCalculated(true);
    }
  }, [worksheetShipmentCode]);

  const defineExpirationMode = () => {
    const isUseExpiration = Boolean(
      sortedData.find((item) => item.expirationMode === 'USE_EXPIRATION'),
    );
    setIsUseExpirationMode(isUseExpiration);
  };

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  const showEditExpirationDateForOneProductModal = (
    productId,
    variantId,
    batchAccountingType,
    batchId,
    batchName,
    batchAccountingNumber,
    isExpirationDaysOverride,
  ) => {
    if (showExpirationDate(currentOrder)) {
      dispatch(
        showModal('EditExpirationDateForOneProduct', {
          itemId: variantId,
          currentOrder,
          currentPackingMaterials,
          setCurrentPackingMaterials,
          isDraft,
          setUnsavedMaterials,
          actualizeOrder,
          handleEditOrder,
          productId,
          batchAccountingType,
          batchId,
          batchName,
          batchAccountingNumber,
          isExpirationDaysOverride,
          worksheetDataFormContent,
          handleShowStockByBatch: async (onClose) => {
            onClose();
            await delay(100);
            dispatch(
              showModal('StockByBatch', {
                warehouses,
                isExcelExport: false,
                stock: [],
                variantId,
                productId,
                openingFromExpirationDateModal: true,
                actualizeOrder,
              }),
            );
          },
        }),
      );
    }
  };

  const getItemsIDs = () => {
    const IDs = [];
    for (let i = 0; i < sortedData.length; i++) {
      if (sortedData[i].variantId === 'delivery') continue;
      IDs.push(sortedData[i].variantId);
    }

    return IDs;
  };

  const createBodyForBatchRequest = () => {
    const ids = getItemsIDs();

    const body = { items: [] };

    for (let i = 0; i < ids.length; i++) {
      body.items.push({
        id: ids[i],
        fbmType: currentDelivery[0]?.fbmType || null,
        percent: null,
      });

      if (worksheetShipmentCode && currentDelivery[0]?.fbmType === 'RETAIL_NETWORK')
        body.items[i].fbmSubTypeCode = worksheetShipmentCode;
    }

    return body;
  };

  const getExpirationDaysCalculated = async () => {
    if (!isUseExpirationMode) return;
    if (currentDelivery[0]?.fbmType === 'RETAIL_NETWORK' && !worksheetShipmentCode) return;

    const tokens = authData.tokenData;

    const body = createBodyForBatchRequest();

    await dispatch(fetchExpirationDaysCalculateBatch(body, tokens)).catch((error) =>
      toast.error(`${t('Ошибка при подсчете ОСГ')}!`),
    );

    switchBatchUpdate(false);
  };

  const handlePackingModal = (item = [], itemIndex) => {
    dispatch(
      showModal('ManagePackingMaterials', {
        item,
        id: currentOrder.id,
        items: currentPackingMaterials,
        type: 'manageOrder',
        currentPackingMaterials: currentPackingMaterials[itemIndex]?.packingMaterials,
        setCurrentPackingMaterials,
        setUnsavedMaterials,
        itemsEditablePermission,
      }),
    );
  };

  const handleFilterMaterials = (itemWithArray) => {
    if (itemWithArray.packingMaterials === undefined) {
      return itemWithArray;
    }

    const newCommonMaterials = itemWithArray.packingMaterials.commonMaterials.filter(
      (item) => item.quantity !== 0,
    );
    const newCustomMaterials = itemWithArray.packingMaterials.customMaterials.filter(
      (item) => item.quantity !== 0,
    );
    const newPackingMaterials = {
      ...itemWithArray,
      packingMaterials: {
        commonMaterials: newCommonMaterials,
        customMaterials: newCustomMaterials,
      },
    };

    return newPackingMaterials;
  };

  const handleUpdatePackingMaterial = async () => {
    const filteredItems = currentPackingMaterials.map((item) => {
      return handleFilterMaterials(item);
    });

    await handleEditOrderItems(filteredItems)
      /*    await dispatch(fetchUpdateOrderItems({ id: currentOrder.id, items: currentPackingMaterials }))*/
      .then(() => toast.info(t('Заказ успешно изменен')))
      .then(() => setUnsavedMaterials(false))
      .catch((err) => toast.error(parseError(err)));
  };

  const checkQuantity = (orderItem) => {
    if (orderItem?.packingMaterials === undefined) {
      return false;
    }
    const items = [
      ...orderItem.packingMaterials.customMaterials,
      ...orderItem.packingMaterials.commonMaterials,
    ];

    return items.reduce((acc, o) => acc + parseInt(o.quantity), 0);
  };

  return (
    <Wrapper className="card-box card-box-main">
      <SpinnerBlock show={loadingOrder} />
      <div className="tags-wrapper">
        {currentOrder.tags && currentOrder.tags.length
          ? currentOrder.tags
              .map((tag) => {
                const currentColor = TAG_COLORS.find((item) => item.id === tag.color);
                return (
                  <label
                    className="tag"
                    style={{ background: currentColor.code }}
                    onClick={(evt) => handleEditTag(evt, currentOrder)}
                  >
                    {tag.name}
                  </label>
                );
              })
              .slice(0, 4)
          : null}
      </div>
      <div className="head-row">
        <div className="head-row-reserve">
          <h4 className="header-title">{t('Заказ')}</h4>
          {!defaultReserveOrders ? (
            <div>
              <h4 className="reserve-toogle">
                <Toogle
                  id="needReserve"
                  onChange={(e) => handleChangeNeedReserve(e.target.checked)}
                  label={t('Резервировать товары')}
                  checked={currentOrder.needReserve}
                />
              </h4>
            </div>
          ) : null}
        </div>
        <div className="head-row-buttons">
          <div className="text-xl-right buttons-panel">
            {unsavedMaterials && (
              <ActionButton
                withoutPermission
                classType="btn btn-primary"
                text={t('Сохранить изменения в заказе')}
                action={() => handleUpdatePackingMaterial()}
              />
            )}
            {!isNew ? (
              <>
                <ActionButton
                  withoutPermission
                  classType="btn-danger"
                  text={t('Задать вопрос')}
                  action={() => handleNewTicket()}
                />

                {currentOrder.delivery &&
                currentOrder.delivery.type === 'SELF_PICKUP' &&
                currentOrder.status === 'ORDER_INFO_PACKED' ? (
                  <ActionButton
                    permissions={permissions}
                    permissionKey="DELIVER_SELF_PICKUP"
                    classType="btn-success"
                    text={t('Выдан получателю')}
                    action={() => handleUpdateDeliveryResult('DELIVERED')}
                  />
                ) : null}

                {!checkOrderConfirmation(currentOrder) ? (
                  <ActionButton
                    permissions={permissions}
                    permissionKey="NEED_CONFIRM"
                    classType="btn-warning"
                    text={t('Подтвердить')}
                    action={handleConfirmation}
                  />
                ) : null}

                {isManualWarehouse && currentOrder.status === 'ORDER_INFO_READY_TO_PACK' ? (
                  <ActionButton
                    permissions={permissions}
                    permissionKey="PACK"
                    loading={loadingSticker}
                    disabled={loadingSticker}
                    classType="btn-warning"
                    text={t('На упаковку')}
                    action={handlePacking}
                  />
                ) : null}

                {isManualWarehouse &&
                currentOrder.status === 'ORDER_INFO_IN_PACKING' &&
                currentOrder.packings &&
                currentOrder.packings.length ? (
                  <ActionButton
                    permissions={permissions}
                    permissionKey="PACK_CONTROL"
                    classType="btn-warning"
                    text={t('Упакован')}
                    action={handleSendPackingControl}
                  />
                ) : null}

                {showUploadFbmDocsButton ? (
                  <ActionButton
                    withoutPermission
                    classType="btn-warning"
                    text={t('Документы загружены')}
                    loading={loadingUploadFbmDocsButton}
                    action={handleUploadFbmDocsButton}
                  />
                ) : null}

                {currentOrder.warehouseFFSync &&
                currentDelivery[0]?.fbmType !== undefined &&
                currentDelivery[0]?.fboDeliveryByCactus &&
                currentOrder.packings?.items?.length !== 0 &&
                currentOrder.driverPermitUploaded !== true ? (
                  <ActionButton
                    withoutPermission
                    classType="btn-warning"
                    text={t('Пропуск заказан')}
                    loading={loadingDriverPermit}
                    action={handleUploadDriverPermit}
                  />
                ) : null}

                {isManualWarehouse &&
                ['ORDER_INFO_IN_PACKING', 'ORDER_INFO_PACKED', 'ORDER_INFO_SHIPPED'].indexOf(
                  currentOrder.status,
                ) !== -1 ? (
                  <ActionButton
                    withoutPermission
                    permissions={permissions}
                    //permissionKey=""
                    classType="btn-light"
                    className="ml-1"
                    icon="fe-printer"
                    text={t('Стикер')}
                    loading={loadingSticker}
                    disabled={loadingSticker}
                    action={handleDownloadSticker}
                  />
                ) : null}

                {currentWarehouse?.fulfillmentType &&
                currentOrder.status === `ORDER_INFO_READY_TO_PACK` &&
                currentOrder.warehouseFFExported === false ? (
                  <ActionButton
                    withoutPermission
                    loading={uploadToFulfilmentLoading}
                    classType="btn-warning"
                    className="ml-1"
                    text={t('Выгрузить на фулфилмент')}
                    action={handleUploadToFulfillment}
                  />
                ) : null}

                {/* <button className="btn btn-light waves-effect ml-1" onClick={handlePrint}>
                                    <i className="fe-printer" /> Печать
                                </button> */}
                <ActionsMenuButton
                  isNew={isNew}
                  currentOrder={currentOrder}
                  showActions={showActions}
                  haveProductsWithoutReserve={haveProductsWithoutReserve}
                  permissions={permissions}
                  setShowActions={setShowActions}
                  handleUploadToFulfillment={handleUploadToFulfillment}
                  handleSetDelivery={handleSetDelivery}
                  handleAcceptReturn={handleAcceptReturn}
                  handleRefreshReserve={handleRefreshReserve}
                  handleCancel={handleCancel}
                  handleUpdateDeliveryResult={handleUpdateDeliveryResult}
                  handleCopyOrder={handleCopyOrder}
                  handleImportFromExcel={handleImportFromExcel}
                  handleSendEmail={handleSendEmail}
                  handleOpenEditSale={handleOpenEditSale}
                  handleOpenPhoneCallBack={handleOpenPhoneCallBack}
                  currentWarehouse={currentWarehouse}
                  handleExportExcel={handleExportExcel}
                  defaultReserveOrders={defaultReserveOrders}
                  handleInvoice={handleInvoice}
                  actualizeOrder={actualizeOrder}
                  worksheetDataRequirements={worksheetDataRequirements}
                  handleUpdatePackingMaterial={handleUpdatePackingMaterial}
                />
              </>
            ) : null}
          </div>
        </div>
      </div>
      <div className="bootstrap-table mt-2">
        <div className="fixed-table-container">
          <div className="fixed-table-body">
            <DisplayMoreWrapper
              array={
                isDraft
                  ? currentPackingMaterials !== undefined && currentPackingMaterials
                  : sortedData
              }
              isTable
              thead={
                <thead className="thead-light">
                  <tr>
                    {adminMode === 'true' && <th></th>}
                    <th className="image-td permission">
                      {!itemsEditablePermission.value ? (
                        <Lock reason={itemsEditablePermission.reason} className={'lock-tooltip'} />
                      ) : (
                        <div
                          className="mass-edit-icon"
                          onClick={(e) => setIsDraft(!isDraft)}
                          style={{}}
                        >
                          {isDraft ? (
                            <i
                              className="dripicons-checklist"
                              title={t('Режим массовой правки активен')}
                              style={{ color: '#7e57c2' }}
                            />
                          ) : (
                            <i
                              className="dripicons-checklist"
                              title={t('Режим массовой правки выключен')}
                            />
                          )}
                        </div>
                      )}
                    </th>
                    <th>{t('Номенклатура')}</th>
                    {isUseExpirationMode && (
                      <th>
                        <div className="help-tooltip-wrapper">
                          {t('ОСГ / Партия')}
                          <i
                            className={`fe-help-circle osg-tooltip ${
                              currentLocale === 'cn' ? 'cn-mode-tooltip' : ''
                            }`}
                          />
                          <span className="help-tooltip">
                            {t('Расчетный остаточный срок годности, дней')}
                            <br />
                            {t('Партия: номер партии')}
                          </span>
                        </div>
                      </th>
                    )}
                    <th>{t('Заказано')}</th>
                    <th>{t('Цена')}</th>
                    <th>{t('Сумма')}</th>
                    <th>{t('Статус')}</th>
                    <th />
                  </tr>
                </thead>
              }
            >
              {({ item, itemIndex }) => (
                <tr key={`${item.productId}=${item.variantId}`}>
                  {adminMode === 'true' && <td>{item.num}</td>}
                  <td className="image-td">
                    {item.variantId !== 'delivery' ? (
                      <div
                        className="image-block"
                        style={{
                          backgroundImage: `url(${getYandexStoreImageMin(item.img, 100)})`,
                        }}
                      />
                    ) : null}
                  </td>
                  <td>
                    {item.variantId !== 'delivery' ? (
                      <>
                        <Link
                          to={{
                            pathname: getProductEncodedUrl(
                              item.productId,
                              item.productVariantCount > 1 ? item.variantId : undefined,
                              null, // params: {}
                              !!item?.multiplicity, // isMonobox: boolean
                            ),
                            state: { customBackLink: history.location.pathname },
                          }}
                          className="item-name"
                        >
                          {item.name}
                        </Link>
                        {item.article ? (
                          <div className="item-article">{`${t('Арт')}.: ${item.article}`}</div>
                        ) : null}
                        <div className="item-subname">{`${item.variantId || item.productId || ''} ${
                          item.variantExtId ? '(' + item.variantExtId + ')' : ''
                        }`}</div>
                      </>
                    ) : (
                      <>
                        <div className="item-name">{item.name}</div>
                        <div className="item-subname">{item.variantId}</div>
                      </>
                    )}
                  </td>

                  {/* ОСГ / Партия */}
                  {item.expirationMode === 'USE_EXPIRATION' ? (
                    !item.batchAccountingType || item.batchAccountingType === 'EXPIRATION_LIMIT' ? (
                      <td
                        className="osg-cell cell-hover"
                        onClick={() => {
                          return showEditExpirationDateForOneProductModal(
                            item.productId,
                            item.variantId,
                            item.batchAccountingType,
                            item.batchId,
                            item.batchName,
                            item.batchAccountingNumber,
                            item.isExpirationDaysOverride,
                          );
                        }}
                      >
                        {item.isExpirationDaysOverride && (
                          <div className="checkbox-icon">
                            <i className="fe-check-square icon-green" />
                          </div>
                        )}
                        <div className="calculateBatch">
                          {calculateBatchValues &&
                            calculateBatchValues.length > 0 &&
                            calculateBatchValues[itemIndex]?.value}
                        </div>
                      </td>
                    ) : item.batchAccountingType === 'BATCH_ID' ? (
                      <td className="osg-cell">
                        <div
                          className={`item-price ${
                            !itemsEditablePermission.value ? 'disabled' : ''
                          }`}
                          onClick={() =>
                            itemsEditablePermission.value
                              ? showEditExpirationDateForOneProductModal(
                                  item.productId,
                                  item.variantId,
                                  item.batchAccountingType,
                                  item.batchId,
                                  item.batchName,
                                  item.batchAccountingNumber,
                                  item?.isExpirationDaysOverride,
                                )
                              : false
                          }
                        >
                          <div className="batch-info">{item.batchName}</div>
                        </div>
                      </td>
                    ) : null
                  ) : isUseExpirationMode ? (
                    <td>{'  '}</td>
                  ) : null}

                  {/* Заказано */}
                  <td>
                    {item.variantId !== 'delivery' ? (
                      <>
                        <div
                          className={`item-quantity ${
                            !itemsEditablePermission.value ? 'disabled' : ''
                          }`}
                          onClick={() =>
                            itemsEditablePermission.value
                              ? handleOpenItemModal(item, itemIndex)
                              : false
                          }
                        >
                          {item.quantity} шт
                        </div>
                        <div className="item-stock">{`${t('Остаток')}: ${
                          item.quantityAvailable
                        }`}</div>
                        {item.itemAmountState.amountORDERED >
                          item.itemAmountState.amountRESERVED && (
                          <div className="item-stock">
                            {t('Резерв')}: {item.itemAmountState.amountRESERVED}
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="delivery-placeholder">{t('Услуга')}</div>
                    )}
                  </td>

                  {/* Цена: */}
                  <td>
                    <div
                      className={`item-price ${!itemsEditablePermission.value ? 'disabled' : ''}`}
                      onClick={() =>
                        itemsEditablePermission.value ? handleOpenItemModal(item, itemIndex) : false
                      }
                    >
                      {`${numeral(item.price).format('0.[00]')} ${currencySymbol}`}
                    </div>
                  </td>

                  {/* Сумма */}
                  <td>
                    <div
                      className={`item-sum ${!itemsEditablePermission.value ? 'disabled' : ''}`}
                      onClick={() =>
                        itemsEditablePermission.value ? handleOpenItemModal(item, itemIndex) : false
                      }
                    >
                      <>
                        {item.variantId !== 'delivery'
                          ? `${numeral(item.price * item.quantity).format(
                              '0.[00]',
                            )} ${currencySymbol}`
                          : `${numeral(item.price).format('0.[00]')} ${currencySymbol}`}
                        <div className="item-nds">
                          {item.vatRate && getNdsValue(item.vatRate)
                            ? `${t('НДС')} ` + getNdsValue(item.vatRate) + '%'
                            : `${t('без НДС')} `}
                        </div>
                      </>
                    </div>
                  </td>

                  {/* Статус */}
                  <td>
                    {item.skuType !== 'SERVICE'
                      ? getItemStatusLabel(item.variantId, itemsStatuses, item.num, t)
                      : null}
                  </td>

                  <td>
                    {item.variantId !== 'delivery' && itemsEditablePermission.value ? (
                      <>
                        <div
                          className="item-remove"
                          onClick={() => handleRemoveItem(item)}
                          title={t('Удалить товар')}
                        >
                          <i className="fe-trash-2" />
                        </div>
                        {account.usePackingMaterials === true && (
                          <>
                            {currentPackingMaterials &&
                            checkQuantity(currentPackingMaterials[itemIndex]) ? (
                              <div
                                className="item-remove"
                                title={t('Изменить упаковочные материалы')}
                                onClick={() =>
                                  handlePackingModal(currentPackingMaterials[itemIndex], itemIndex)
                                }
                              >
                                <i className="fe-file-plus" style={{ color: 'green' }} />
                              </div>
                            ) : (
                              <div
                                className="item-remove"
                                title={t('Добавить упаковочные материалы')}
                                onClick={() =>
                                  handlePackingModal(currentPackingMaterials[itemIndex], itemIndex)
                                }
                              >
                                <i className="fe-file" />
                              </div>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {account.usePackingMaterials === true && item.name !== 'Доставка' && (
                          <>
                            {currentPackingMaterials &&
                            checkQuantity(currentPackingMaterials[itemIndex]) ? (
                              <div
                                className="item-remove"
                                title={t('Изменить упаковочные материалы')}
                                onClick={() =>
                                  handlePackingModal(currentPackingMaterials[itemIndex], itemIndex)
                                }
                              >
                                <i className="fe-file-plus" style={{ color: 'green' }} />
                              </div>
                            ) : (
                              <div
                                className="item-remove"
                                title={t('Добавить упаковочные материалы')}
                                onClick={() =>
                                  handlePackingModal(currentPackingMaterials[itemIndex], itemIndex)
                                }
                              >
                                <i className="fe-file" />
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              )}
            </DisplayMoreWrapper>
          </div>
        </div>
      </div>
      <div className="row bottom-block">
        <div className="col-6" style={{ paddingLeft: 0, display: 'flex' }}>
          {itemsEditablePermission.value ? (
            <div className="add-item" onClick={handleAddItem}>
              + {t('Новая позиция')}
            </div>
          ) : null}
          {(defaultReserveOrders || (!defaultReserveOrders && currentOrder.needReserve)) &&
          haveProductsWithoutReserve &&
          (!refreshReservePermission || refreshReservePermission.value) ? (
            <div
              className={`refresh-reserve ml-3 ${
                refreshReservePermission && !refreshReservePermission.value
                  ? 'disabled help-tooltip-wrapper'
                  : ''
              }`}
              onClick={
                refreshReservePermission && !refreshReservePermission.value
                  ? () => false
                  : handleRefreshReserve
              }
            >
              {t('Обновить резерв')}
              {refreshReservePermission &&
              !refreshReservePermission.value &&
              refreshReservePermission.reason ? (
                <span className="help-tooltip">{refreshReservePermission.reason}</span>
              ) : null}
            </div>
          ) : null}
        </div>
        <div className="col-6" style={{ paddingRight: 0 }}>
          <div className="items-total text-lg-right">
            <div>
              {`${t('Всего товаров')}: ${allQuantity}  | ${t('Сумма')}${
                hasDiscount ? ` ${t('до скидки')}` : ``
              }: ${numeral(hasDiscount ? getPriceBeforeDiscount(sum) : sum).format(
                '0.[00]',
              )} ${currencySymbol}`}
            </div>
            {currentOrder.promocode ? (
              <div style={{ color: 'rgb(241, 85, 108)' }}>{`${t('Промокод')} [${
                currentOrder.promocode
              }]${
                currentOrder.promocodeAppliedDiscount
                  ? ': -' +
                    numeral(currentOrder.promocodeAppliedDiscount).format('0.[00]') +
                    ' ' +
                    currencySymbol
                  : ''
              }`}</div>
            ) : null}
            {currentOrder.paymentMethodAppliedDiscount ? (
              <div style={{ color: 'rgb(241, 85, 108)' }}>{`${t('Скидка за способ оплаты')}${
                currentOrder.paymentMethodAppliedDiscount
                  ? ': ' +
                    numeral(currentOrder.paymentMethodAppliedDiscount).format('0.[00]') +
                    ' ' +
                    currencySymbol
                  : ''
              }`}</div>
            ) : null}
            {currentOrder.manualAppliedDiscount ? (
              <div style={{ color: 'rgb(241, 85, 108)' }}>{`${t('Скидка вручную')}${
                currentOrder.manualAppliedDiscount
                  ? ': ' +
                    numeral(currentOrder.manualAppliedDiscount).format('0.[00]') +
                    ' ' +
                    currencySymbol
                  : ''
              }`}</div>
            ) : null}
            <div
              style={{
                fontWeight: 700,
                textDecoration: sum != factSum ? 'line-through' : 'none',
              }}
            >{`${t('Итого')}: ${numeral(sum).format('0.[00]')} ${currencySymbol}`}</div>
            <div style={{ textDecoration: sum != factSum ? 'line-through' : 'none' }}>{`${t(
              'В том числе НДС:',
            )} ${numeral(getTotalNds(currentOrder)).format('0.[00]')} ${currencySymbol}`}</div>
            {!isNew ? (
              <>
                <div style={{ fontWeight: 700, color: '#1abc9c' }}>{`${t('Продано')}: ${numeral(
                  factSum,
                ).format('0.[00]')} ${currencySymbol}`}</div>
                <div style={{ color: '#1abc9c' }}>{`${t('В том числе НДС:')} ${numeral(
                  getTotalNds(currentOrder, true),
                ).format('0.[00]')} ${currencySymbol}`}</div>
              </>
            ) : null}
          </div>
        </div>
      </div>
      {!haveProducts ? (
        <div
          className="alert alert-light mt-2"
          role="alert"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <i className="fe-alert-circle mr-2" style={{ fontSize: '20px' }} />
          <span>{t('Для разблокировки всех настроек заказа, добавьте товары')}</span>
        </div>
      ) : null}
    </Wrapper>
  );
};

export default DesktopMainBlock;
